
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    rating: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    stars(): string[] {
      const stars = [] as any[];
      const fullStars = Math.floor(this.rating);
      for (let i = 0; i < fullStars; i++) stars.push('is-full');
      if (this.rating % 1 === 0.5) stars.push('is-half');
      for (let i = stars.length; i < 5; i++) {
        stars.push('is-empty');
      }
      return stars;
    },
  },
});
